import { Collections } from '../../firebase/firestore/collections';
import { useDocumentSnapshot } from '../../firebase/firestore/hooks';
import { EngagedCandidate } from '../../firebase/firestore/documents/candidate';

const useSingleCandidate = (candidateId: string | undefined): EngagedCandidate | undefined => {
  return useDocumentSnapshot<Readonly<EngagedCandidate>>(Collections.CANDIDATES, candidateId);
};
export default useSingleCandidate;
